import { useLogAnalyticsEventClient } from "@/firebase/useLogAnalyticsEventClient";
import type { AnalyticsEventType } from "@/firebase/analyticsEventTypes";
import type { Analytics } from "firebase/analytics";
export type { AnalyticsEventType };
let analyticsReady: Promise<{
  logEvent: typeof import("firebase/analytics").logEvent;
  instance: Analytics | null;
}> | null = null;
function loadAnalytics() {
  if (!analyticsReady) {
    analyticsReady = (async () => {
      const [{
        getAnalytics,
        isSupported,
        logEvent
      }, {
        app
      }] = await Promise.all([import("firebase/analytics"), import("@/firebase/firebaseConfig")]);
      const supported = await isSupported().catch(() => false);
      return {
        logEvent,
        instance: supported ? getAnalytics(app) : null
      };
    })();
  }
  return analyticsReady;
}

/**
 * Log an analytics event to Firebase Analytics.
 * The Analytics SDK loads on the first call so auth pages do not download it up front.
 */
export const logAnalyticsEvent = async (event: AnalyticsEventType, eventParams?: Object) => {
  try {
    const {
      logEvent,
      instance
    } = await loadAnalytics();
    if (!instance) {
      console.log("Event: '" + event + "'", eventParams ? "with params:" : "", eventParams ? eventParams : "");
      return;
    }
    logEvent(instance, event as string, {
      platform: "web",
      ...eventParams
    });
  } catch (error) {
    console.error("Error logging analytics event:", error);
    console.log("Event: '" + event + "'", eventParams ? "with params:" : "", eventParams ? eventParams : "");
  }
};

/**
 * Wrapper for the useLogAnalyticsEventClient hook so that it doesn't die when run on the server side
 */
export const useLogAnalyticsEvent = typeof window === 'undefined' ? logAnalyticsEvent : useLogAnalyticsEventClient;